import { Dialog } from "@headlessui/react";
import { useEffect, useRef, useState } from "react";
import ReactCrop, { centerCrop, makeAspectCrop } from "react-image-crop";
import Button from "../basic/Button";
import CustomDialog from "../basic/Dialog";

import "react-image-crop/dist/ReactCrop.css";

function getCroppedImage(sourceImage, cropConfig, fileName) {
  // creating the cropped image from the source image
  const canvas = document.createElement("canvas");
  const scaleX = sourceImage.naturalWidth / sourceImage.width;
  const scaleY = sourceImage.naturalHeight / sourceImage.height;
  canvas.width = cropConfig.width;
  canvas.height = cropConfig.height;
  const ctx = canvas.getContext("2d");

  ctx.drawImage(
    sourceImage,
    cropConfig.x * scaleX,
    cropConfig.y * scaleY,
    cropConfig.width * scaleX,
    cropConfig.height * scaleY,
    0,
    0,
    cropConfig.width,
    cropConfig.height
  );

  return new Promise((resolve, reject) => {
    canvas.toBlob((blob) => {
      // returning an error
      if (!blob) {
        reject(new Error("Canvas is empty"));
        return;
      }

      blob.name = fileName;

      resolve(blob);
    }, "image/png");
  });
}

function centerAspectCrop(mediaWidth, mediaHeight, aspect) {
  return centerCrop(
    makeAspectCrop(
      {
        unit: "%",
        width: 90,
      },
      aspect,
      mediaWidth,
      mediaHeight
    ),
    mediaWidth,
    mediaHeight
  );
}

function ImageCropDialog({ show, close, image, aspectRatio }) {
  const imgRef = useRef();
  const [imgSrc, setImgSrc] = useState();
  const [crop, setCrop] = useState({
    unit: "%", // Can be 'px' or '%'
    x: 25,
    y: 25,
    width: 50,
    height: 50,
  });

  function onImageLoad(e) {
    if (aspectRatio) {
      const { width, height } = e.currentTarget;
      setCrop(centerAspectCrop(width, height, aspectRatio));
    }
  }

  useEffect(() => {
    if (image) {
      setCrop(undefined); // Makes crop preview update between images.
      const reader = new FileReader();
      reader.addEventListener("load", () =>
        setImgSrc(reader.result.toString() || "")
      );
      reader.readAsDataURL(image);
    }
  }, [image]);

  return (
    <CustomDialog show={show} close={close}>
      <Dialog.Panel
        className={`w-full max-w-xl transform space-y-5 rounded-2xl bg-white p-6 flex flex-col justify-center shadow-xl transition-all`}
      >
        {imgSrc && (
          <ReactCrop
            crop={crop}
            onChange={(crop) => setCrop(crop)}
            aspect={aspectRatio}
          >
            <img ref={imgRef} alt="Crop me" src={imgSrc} onLoad={onImageLoad} />
          </ReactCrop>
        )}
        <Button
          type={"primary"}
          onClick={async () => {
            if (imgRef && crop.width && crop.height) {
              const croppedImage = await getCroppedImage(
                imgRef.current,
                crop,
                "croppedImage.jpeg" // destination filename
              );
              // calling the props function to expose
              // croppedImage to the parent component
              close(croppedImage);
            }
          }}
          className={"max-w-max flex self-center"}
        >
          <p>Update Avatar</p>
        </Button>
      </Dialog.Panel>
    </CustomDialog>
  );
}

export default ImageCropDialog;
